// @flow

import React from 'react';
import { Cookies, withCookies } from 'react-cookie';
import { I18n } from 'react-redux-i18n';
import { twCurrency, twSurfaceUnit } from '../../const';
import type { SelectConvertorMap, User } from '../../types/commonTypes';
import CookieSwitchSelector from './CookieSwitchSelector';
import CloseableComponent from './CloseableComponent';
import CookieSelector from './CookieSelector';
import { isUSDorGBP } from '../../utils/utils';

type Props = {
  userInfo: User,
  currenciesList: SelectConvertorMap,
  cookies: Cookies,
}

type State = {
  userInfoOpened: boolean,
}

class UserInfoDropdown extends React.Component<Props, State> {
  state: State = {
    userInfoOpened: false,
  };

  buttonRef: HTMLButtonElement;

  handleClick = () => {
    this.toggleList();
  };

  toggleList = () => {
    this.setState({
      userInfoOpened: !this.state.userInfoOpened,
    });
  };

  render() {
    return (
      <div className="user-info">
        <button
          ref={(ref) => {
            if (ref && !this.buttonRef) {
              this.buttonRef = ref;
            }
          }}
          className="user-info-header"
          type="button"
          onClick={this.handleClick}
        >
          <i className={`fa fa-angle-left${this.state.userInfoOpened ? ' open' : ''}`} />
          <i className="fas fa-cog" />
          <p>{`${this.props.userInfo.firstName} ${this.props.userInfo.lastName}`}</p>
        </button>
        <CloseableComponent isOpened={this.state.userInfoOpened} buttonRef={this.buttonRef} toggle={this.toggleList}>
          <div className={`user-info-body${this.state.userInfoOpened ? ' open' : ''}`}>
            <div className="user-desc">
              <i className="fas fa-user-cog" />
              {this.props.userInfo.email}
            </div>
            <hr />
            <div className="convertor-selector">
              <CookieSwitchSelector
                cookieToSet={twSurfaceUnit}
                title={I18n.t('SIDE_MENU.dimension')}
                leftValue="m"
                rightValue="ft"
              />
              <hr />
              <CookieSelector
                cookieToSet={twCurrency}
                title={I18n.t('SIDE_MENU.CURRENCY_LOWER')}
                values={Object.keys(this.props.currenciesList || {}).sort((a, b) => this.props.currenciesList[a].order - this.props.currenciesList[b].order)}
              />
              <hr />
              <div className="selector">{I18n.t('SIDE_MENU.CONVERSION_RATE')}
                {
                  this.props.currenciesList[this.props.cookies.get(twCurrency)] &&
                  <div className="conversion-rate">
                    {I18n.t(`SIDE_MENU.CONVERSION_FACTOR${isUSDorGBP(this.props.cookies.get(twCurrency)) ? '_EN' : ''}`, {
                      factor: this.props.currenciesList[this.props.cookies.get(twCurrency)].convertorFactor,
                      symbol: this.props.currenciesList[this.props.cookies.get(twCurrency)].symbol,
                    })}
                  </div>
                }
              </div>
            </div>
          </div>
        </CloseableComponent>
      </div>
    );
  }
}

export default withCookies(UserInfoDropdown);
